import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';

export interface IUpdateNotificationContactState {
  state: QueryState;
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const UpdateNotificationContactEmptyState: IUpdateNotificationContactState = {
  state: QueryState.UNDEFINED,
  error: null,
  accessToken: undefined
};
